// Copyright (c) 2023 Proto Labs, Inc. All Rights Reserved.

import { ILinkGroup } from '@/interfaces';
import { defaultGetOptions, getErrorMessage, logErrorToConsole } from '@/utils/apiUtils';
import { Type } from '@/utils/result';

export async function getCountriesAsync(): Promise<Type<Array<any>>> {
    try {
        const response = await fetch(
            '/i18n/countries.json',
            defaultGetOptions()
        );
        if (response.ok) {
            return await response.json();
        } else {
            throw new Error(response.statusText);
        }
    } catch (error) {
        logErrorToConsole(error);
        return new Error(getErrorMessage(error));
    }
}

export async function getDefaultCountryAsync(): Promise<Type<string>> {
    try {
        const response = await fetch(
            '/i18n/currentlocation',
            defaultGetOptions()
        );
        if (response.ok) {
            return await response.text();
        } else {
            throw new Error(response.statusText);
        }
    } catch (error) {
        logErrorToConsole(error);
        return new Error(getErrorMessage(error));
    }
}

export async function getLinkGroupsAsync(): Promise<
    Type<Array<ILinkGroup>>
> {
    try {
        const response = await fetch(
            '/i18n/linkGroups.json',
            defaultGetOptions()
        );
        if (response.ok) {
            return await response.json();
        } else {
            throw new Error(response.statusText);
        }
    } catch (error) {
        logErrorToConsole(error);
        return new Error(getErrorMessage(error));
    }
}

export default {
    getLinkGroupsAsync,
};
